import React, {useMemo} from 'react';
import InRangeSelect from 'components/common/form/select/InRangeSelect';
import {formatPercent} from 'lib/currency';
import {useHECMFixedRatesQuery} from 'query/products/hecm/hecmFixedRates';
import {useFormContext} from 'react-hook-form';

FixedRatesSelect.propTypes = {};

function FixedRatesSelect(props = {}) {
  const {defaultValue: defValue, ...rest} = props;
  const {data: fixedRates = [], defaultRate} = useHECMFixedRatesQuery();

  const {watch} = useFormContext();
  const [StateValue] = watch(['BorrowerProfile.State']);

  var fixedRatesByState = fixedRates.filter(rate => rate.State === StateValue);
  fixedRatesByState = fixedRatesByState.length ? fixedRatesByState : fixedRates.filter(rate => rate.State == null);
  const fixedRatesSorted = fixedRatesByState.sort((a,b) => a.FixedRate > b.FixedRate ? -1 : 1);
  const defaultValue = useMemo(() => defValue ?? defaultRate?.FixedRate, [defValue, defaultRate?.FixedRate]);

  const data = useMemo(
    () =>
      fixedRatesSorted.map((Rate) => ({
        value: Rate.FixedRate,
        label: formatPercent(Rate.FixedRate),
        selected: Rate.FixedRate === defaultValue,
      })),
    [fixedRatesSorted, defaultValue, StateValue],
  );

  return <InRangeSelect {...rest} options={data} defaultValue={defaultValue} />;
}

export default FixedRatesSelect;
